import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, NavigationEnd, ParamMap, Route, Router } from '@angular/router';
import { ConfirmationModalComponent, ConfirmDialogModel } from 'src/app/modals/confirmation-modal/confirmation-modal.component';
import { AuthService } from 'src/app/services/auth.service';
import { CoachService } from "src/app/services/coach.service";
import Swal from 'sweetalert2';

@Component({
    selector: 'app-sidebar-nav',
    templateUrl: './sidebar-nav.component.html',
    styleUrls: ['./sidebar-nav.component.scss']
})
export class SidebarNavComponent implements OnInit {
    show_menu:boolean=false;
    subscription_type:any='';
    coach_id:any=null;
    user_type:any;
    sport_level:any=null;

    constructor(
        private authService: AuthService,
        private matDialog: MatDialog,
        private coachService: CoachService,
        private activatedRoute:ActivatedRoute,
        private router:Router

    ) { }

    ngOnInit(): void {


      this.fetchNotificationCount();
      this.coachService.showleftMenue.subscribe(res=>{
    if(res==true)
    {
        this.fetchNotificationCount();
        this.coachService.showleftMenue.next(false);
    }
   })
   this.coachService.sportLevel$.subscribe(res=>{
   if(res)
    {
      this.sport_level=res;
    }
   })
   let current_url=this.router.url.split("/").filter(element => element != null && element !== '');


   if(current_url.length==3)
    {
      this.coach_id=current_url[1];
    }
    else if(current_url.length==4 || current_url.length==5)
    {
      this.coach_id=current_url[2];
    }
    else{
      this.coach_id=null;
    }
    this.user_type=this.authService.getCoachSessionDetails()?.user_type;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {

        let current_url=event.urlAfterRedirects.split("/").filter(element => element != null && element !== '');;
        if(current_url.length==3)
          {
            this.coach_id=current_url[1];
          }
          else if(current_url.length==4 || current_url.length==5)
            {
              this.coach_id=current_url[2];
            }
          else{
            this.coach_id=null;
          }
      }
    });



  }


    logout() {
        // this.matDialog.open(ConfirmationModalComponent, {
        //     maxWidth: "400px",
        //     data: new ConfirmDialogModel("Logout", `Are you sure you want to logout?`)
        // }).afterClosed().subscribe(dialogResult => {
        //     if (dialogResult === true) {
        //         this.authService.coachLogout();
        //     }
        // });
        Swal.fire({
          title: 'LOGOUT',
          text: "Are you sure you want to logout?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes'
        }).then((result) => {
          if (result.isConfirmed) {
            this.authService.coachLogout();
          }
        })
    }
    fetchNotificationCount() {
        return new Promise((resolve, reject) => {
          this.coachService.countNotification({}).subscribe(
            res => {
              const data = res.data;

              // console.log(res);
              if (res.status == "success") {
                this.subscription_type=data.subscription_type;
                if(this.subscription_type!='')
                {
                    this.show_menu=true;
                }

                resolve(true);
              } else {
                reject(res.message);
              }
            },
            err => {
              if (err.status == 406) {
                this.show_menu=false;

              }
              else if (err.status == 403) {

              }
              else {

              }
              //reject(Global.getServerErrorMessage(err));
            }
          );
        });
      }
}
